<template lang="pug">
  .component-reservation-action-buttons
    .dropdown-buttons
      .stacked-for-small.button-group
        button.button.alert(@click="$router.push({path:`${item.id}/edit`, name:'edit-plan-reservation-rates', params:{rateId: item.id}})") Edit
        button.button.alert(@click="remove") Delete
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import MaggieHelper from "src/maggieHelper"

  export default {
    name: "PlanReservationRateActionButtons",
    components: {},
    data() {
      return {
        entity: null
      }
    },
    created() {
    },
    methods: {
      remove() {
        this.$confirm('Are you sure?', 'Do you really want delete this plan reservation rate?', () => {
          KeplerBackofficeSdk.planReservationRates.select(this.item).remove(() => {
            MaggieHelper.notification('Deleted', 'Plan reservation rate deleted successfully')
            this.$emit('deleted')
          })
        })
      },

    },
    computed: {},
    props: ['item']
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// PlanReservationRateActionButtons.vue?cdeec3ac